import { getFileExtensionFromUrl, isPatentUrl } from '#pplx/frontend/common/files/urls.js';
import { getFileVisualStyleForExtension } from '#pplx/frontend/components/links/fileTypeVisuals.js';
import { isPatentResult } from '#pplx/frontend/components/utils/attachmentsUtils.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
export const ContentType = {
    // keep in sync with ContentType in BE
    PDF: 'pdf',
    TXT: 'txt',
    CSV: 'csv',
    XLSX: 'xlsx',
    DOCX: 'docx',
    PPTX: 'pptx',
    MARKDOWN: 'md',
    JSON: 'json',
    JPG: 'jpg',
    JPEG: 'jpeg',
    PNG: 'png',
};
export const isPdfUrl = (url) => {
    // Check file extension
    const extension = getFileExtensionFromUrl(url);
    if (extension === ContentType.PDF) {
        return true;
    }
    // Check for known PDF-serving domains
    if (isPatentUrl(url)) {
        return true;
    }
    return false;
};
export const getFileIcon = (url) => {
    const extension = getFileExtensionFromUrl(url);
    const isPatentFile = isPatentUrl(url);
    if (isPatentFile) {
        return $icon('file-type-pdf');
    }
    switch (extension) {
        case ContentType.TXT:
            return $icon('file-text');
        case ContentType.MARKDOWN:
            return $icon('file-text');
        case ContentType.PDF:
            return $icon('file-type-pdf');
        case ContentType.XLSX:
            return $icon('file-spreadsheet');
        case ContentType.CSV:
            return $icon('file-type-csv');
        case ContentType.DOCX:
            return $icon('file-type-doc');
        case ContentType.PPTX:
            return $icon('file-type-ppt');
        case ContentType.JPG:
        case ContentType.JPEG:
        case ContentType.PNG:
            return $icon('photo');
        default:
            return $icon('file');
    }
};
export const getFileVisualStyle = (url) => getFileVisualStyleForExtension(getFileExtensionFromUrl(url));
/**
 * Checks if a web result is a meeting transcript based on its file metadata.
 * @param result - The web result to check
 * @returns true if the result is a meeting transcript, false otherwise
 */
export const isMeetingTranscript = (result) => {
    return result?.file_metadata?.file_source === 'MEETING_TRANSCRIPT';
};
export function shouldOpenInFileViewer(resultOrUrl, fileSource) {
    // Sidecar builds don't have the FileViewerContext provider
    const isSidecar = import.meta.env.VITE_IS_SIDECAR_BUILD ||
        import.meta.env.VITE_IS_EMBEDDED_SIDECAR_BUILD ||
        import.meta.env.VITE_IS_MOBILE_SIDECAR_BUILD;
    if (isSidecar)
        return false;
    // Handle URL + fileSource overload
    if (typeof resultOrUrl === 'string') {
        return fileSource !== 'MEETING_TRANSCRIPT' && isPdfUrl(resultOrUrl);
    }
    // Handle WebResult overload
    const result = resultOrUrl;
    if (!result || !result.url)
        return false;
    return !isMeetingTranscript(result) && (isPatentResult(result) || isPdfUrl(result.url));
}
//# sourceMappingURL=fileContentUtils.js.map